import React, {useContext, useState} from 'react';
import IframeWidget from "../../utils/IframeWidget";
import {Modal} from "react-bootstrap";
import MenuProductListItemComponent from "../../pages/Menu/components/List/MenuProductListItemComponent";
import {usePrefix} from "../../services/Prefix";
import {useNavigate} from "react-router-dom";
import ItemViewHelper from "../../services/Menu/services/Item/ItemViewHelper";
import {useTranslation} from "react-i18next";
import {VoucherProductsContext} from "../../services/VoucherProducts/VoucherProductsContext";
import AppConfig from "../../services/AppConfig";
import PromotionItemAddModal from "./PromotionItemAddModal";

interface Props {
    show: boolean;
    onHide: () => void;
    promotions: any[];
    availabilities: any[];
    session: any;
    cart: any;
    isStorePaused: boolean;
    categories: any[];
    menus: any;
    usePromotionItemModal?: boolean;
    items: any[];
    itemGroups: any[];
}

const VoucherProductsModal = ({
                                  show,
                                  onHide,
                                  categories,
                                  promotions,
                                  availabilities,
                                  session,
                                  cart,
                                  isStorePaused,
                                  menus,
                                  usePromotionItemModal,
                                  items,
                                  itemGroups
                              }: Props) => {
    const prefix = usePrefix();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const {promotionItems, handleRemovePromotion} = useContext(VoucherProductsContext);
    const [promotionItem, setPromotionItem] = useState<Record<string, any> | undefined>();
    const [itemMenuId, setItemMenuId] = useState<number | undefined>()

    if (isStorePaused) return null;

    const handleOnHide = async () => {
        if (!hasAnyPromotionItemsInCart()) {
            await handleRemovePromotion();
        }
        onHide();
        IframeWidget.onHide(onHide);
    }

    const findMenuForPromotionItem = (promotionItem: any) => {
        const itemCategory = categories.find(category => category.entities.map((entity: any) => entity.entity_id).includes(promotionItem.id));

        if (!itemCategory) return undefined;

        return menus.find((menu: any) => {
            const category = menu.categories.find((menuCategory: any) => menuCategory.category_id === itemCategory.id);

            if (category) return menu.id;

            return undefined;
        })?.id;
    }

    const hasAnyPromotionItemsInCart = () => {
        const itemsIds = promotionItems.map(item => item.id);

        return cart.items.some((cartItem: any) => itemsIds.includes(cartItem.item_id));

    }

    const handleAddItem = (menuId: number | undefined, item: Record<string, any>) => {
        if (!menuId) return;
        if (usePromotionItemModal) {
            setPromotionItem(item);
            setItemMenuId(menuId)
        } else {
            const state = {
                back: true,
                fromVoucher: true
            };
            navigate(AppConfig.getLinkWithPrefix(`/menu/${menuId}/add/${item.id}`, prefix), {state});
        }
    }

    const handleOnPromotionItemModalHide = () => {
        setPromotionItem(undefined)
        setItemMenuId(undefined)
    }

    return (
        <>
            {promotionItem &&
                <PromotionItemAddModal items={items} menus={menus} menuId={itemMenuId} itemId={promotionItem.id}
                                       vouchers={[]} show={!!promotionItem} onHide={handleOnPromotionItemModalHide}
                                       cart={cart} itemGroups={itemGroups} preventRemovePromotionOnHide/>}

            <Modal dialogClassName={"modal-full voucher-products-modal"} show={show} onHide={handleOnHide}
                   onShow={() => IframeWidget.onShow()}
                   aria-labelledby="voucher_products_modal_title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="voucher_products_modal_title">
                        {t("modules.voucher.field.choose_product.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column w-100">
                        {
                            promotionItems.map((item, index) => {
                                const menuId = findMenuForPromotionItem(item);

                                if (!menuId) return;

                                const parsedItem = ItemViewHelper.parseItem(item, availabilities, promotions, session.pickup_at, undefined, cart, session.order_type);

                                return (
                                    <React.Fragment key={item.id}>
                                        <MenuProductListItemComponent menuId={menuId}
                                                                      product={parsedItem}
                                                                      promotions={promotions}
                                                                      addItem={() => handleAddItem(menuId, item)}
                                        />
                                        {index !== promotionItems.length - 1 && <hr/>}
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default VoucherProductsModal;